import React, { FC, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CustomContainerProps {
  children: ReactNode;
  className?: string;
}

const CustomContainer: FC<CustomContainerProps> = ({ children, className }) => (
  <div className={cn("w-full mx-auto py-2", className)}>
    {children}
  </div>
);

export default CustomContainer;